import React from "react";
import TicketDetailItemPrivate from "./TicketDetailItemPrivate";
import TicketDetailItemPublic from "./TicketDetailItemPublic";

const ticketIsPrivate = (item) => {
  const hasTypeAccess = !Boolean(
    item && item.accessibleByTypes && item.accessibleByTypes.length,
  );
  return hasTypeAccess;
};

const TicketDetailItem = ({ item }) => {
  const isPrivate = ticketIsPrivate(item);

  return isPrivate ? (
    <TicketDetailItemPrivate item={item} />
  ) : (
    <TicketDetailItemPublic item={item} />
  );
};

export default TicketDetailItem;
